export default __webpack_public_path__ + "static/media/exceptionalATeamer.353aafed.svg";